import { formatMoney } from '../../lib/formatters'
import type { SupplierQuoteResponseItem } from './types'

/** Computed explanation only; original supplier response inputs remain untouched. */
export function ConfigurationCostSummary({ cost, pending = false }: { cost: SupplierQuoteResponseItem['configurationCost']; pending?: boolean }) {
  if (!cost?.contributions.length) return null
  return <div className="my-3 rounded-lg border border-pine-100 bg-pine-50 p-3 text-xs text-pine-900">
    <p className="font-semibold">{cost.allocationOnly ? 'Fulfilled by assigned parts — no 1:1 supplier match required.' : 'Primary supplier cost plus assigned parts.'}</p>
    {pending && <p className="mt-1">Provisional assignments. Approve with Save &amp; mark reviewed.</p>}
    {cost.primaryCostEur !== null && <p className="mt-1">Primary cost: {formatMoney(cost.primaryCostEur)}</p>}
    <p className="mt-1">Assigned costs: {formatMoney(cost.allocatedCostEur)}</p>
    <p className="font-semibold">Configuration pricing basis: {formatMoney(cost.effectivePricingCostEur)}</p>
    <details className="mt-2"><summary className="cursor-pointer">Contributing supplier lines ({cost.contributions.length})</summary>
      <ul className="mt-1 space-y-1">{cost.contributions.map((source) => <li key={source.supplierQuoteItemId}>{source.position || source.supplierQuoteItemId} · {formatMoney(source.amountEur)}</li>)}</ul>
    </details>
  </div>
}
